import {t} from "@lingui/core/macro";
import {StyleSheet} from "aphrodite";
import * as React from "react";

import {View} from "@khanacademy/wonder-blocks-core";
import Link from "@khanacademy/wonder-blocks-link";
import {HeadingLarge, LabelLarge} from "@khanacademy/wonder-blocks-typography";
import {
    withMarkConversion,
    type WithMarkConversionProps,
    type WithoutMarkConversion,
} from "@khan/analytics-learning-time";

import BadgesView from "#badges-package/badges-view.tsx";

import type {Profile} from "./profile-util.ts";

type OwnProps = {
    kaid: string;
    profilePromise: Promise<Profile>;
    profilePath: string;
    isMyPage: boolean;
    onSufficientlyUsable: () => void;
};

type Props = OwnProps & WithMarkConversionProps;

class Badges extends React.Component<Props> {
    componentDidMount() {
        const {markConversion} = this.props;
        markConversion({id: "logged_in_homepage_visit"});
    }

    componentDidUpdate(prevProps: Props) {
        if (prevProps.kaid !== this.props.kaid) {
            const {markConversion} = this.props;
            markConversion({id: "logged_in_homepage_visit"});
        }
    }

    render(): React.ReactNode {
        const {kaid, onSufficientlyUsable, profilePath, profilePromise} =
            this.props;

        return (
            <View style={styles.container}>
                <LabelLarge style={styles.breadcrumb}>
                    <Link href={profilePath}>{t`< Profile`}</Link>
                </LabelLarge>
                <HeadingLarge style={styles.heading}>{t`Badges`}</HeadingLarge>
                <BadgesView
                    profilePromise={profilePromise}
                    kaid={kaid}
                    onSufficientlyUsable={onSufficientlyUsable}
                    spotlightBadgeSlug={null}
                />
            </View>
        );
    }
}

const styles = StyleSheet.create({
    container: {
        marginBottom: 32,
    },
    breadcrumb: {
        marginBottom: 4,
    },
    heading: {
        marginBottom: 12,
    },
});

type ExportProps = WithoutMarkConversion<
    JSX.LibraryManagedAttributes<
        typeof Badges,
        React.ComponentProps<typeof Badges>
    >
>;

export default withMarkConversion(Badges) as React.ComponentType<ExportProps>;
